import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import frameImage from "../../assets/img/wedding-photobooth-frame.png";
import firstPhoto from "../../assets/img/wedding-photobooth-together.jpg";
import secondPhoto from "../../assets/img/wedding-photobooth-kiss.jpg";
import "../../components/Wedding/wedding.css";
import "./WeddingAnnouncement.css";
import { InvitationLanguageProvider, InvitationLanguageSwitcher, useInvitationLanguage } from "./InvitationLanguage";
import WeddingInvitationCollage from "./WeddingInvitationCollage";

export default function WeddingAnnouncement() {
  return <InvitationLanguageProvider><WeddingAnnouncementContent /></InvitationLanguageProvider>;
}

function WeddingAnnouncementContent() {
  const { language, t } = useInvitationLanguage();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>{t("Hương & Lượng - We’re getting married!", "Hương & Lượng - Chúng mình chính thức về chung một nhà")}</title>
        <meta name="description" content={t("Hương & Lượng — We’re getting married! Open our wedding invitation.", "Hương & Lượng — Trân trọng mời bạn đến chung vui trong ngày cưới của chúng mình.")} />
      </Helmet>
      <main className="wedding-announcement-page" lang={language} aria-labelledby="announcement-names">
      <InvitationLanguageSwitcher />
      <section className="wedding-announcement" aria-labelledby="announcement-names">
        <header className="wedding-announcement__heading">
          <p className="wedding-announcement__eyebrow">{t("WE ARE GETTING MARRIED!", "CHÚNG MÌNH CHÍNH THỨC VỀ CHUNG MỘT NHÀ")}</p>
          <h1 id="announcement-names" className="wedding-announcement__names">Hương &amp; Lượng</h1>
        </header>

        <div className="wedding-photobooth">
          <img className="wedding-photobooth__frame" src={frameImage} alt="" width="481" height="800" />
          <div className="wedding-photobooth__slot" aria-hidden="true" />
          <div className="wedding-photobooth__print-area">
            <figure className="wedding-photobooth__strip">
              <img src={firstPhoto} alt={t("Hương and Lượng standing together in traditional Vietnamese attire", "Hương và Lượng trong tà áo dài")} />
              <img src={secondPhoto} alt={t("Lượng kissing Hương on the cheek", "Lượng hôn lên má Hương")} />
              <figcaption><time dateTime="2027-01-17">17.01.2027</time></figcaption>
            </figure>
          </div>
        </div>

        <Link className="wedding-announcement__open" to={language === "vi" ? "/tramnamhanhphuc?lang=vi" : "/tramnamhanhphuc"} onClick={() => window.scrollTo(0, 0)}>
          {t("OPEN INVITATION", "MỞ THIỆP MỜI")}
        </Link>
        <button className="wedding-announcement__scroll" type="button" onClick={() => document.getElementById("invitation-collage")?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" })}>
          <span>{t("MORE LOVE BELOW", "CÒN NHIỀU YÊU THƯƠNG PHÍA DƯỚI")}</span>
          <svg viewBox="0 0 64 56" width="56" height="49" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
            <path d="M32 14C20 14 19 4 24 5c4 0 6 5 8 9Zm0 0C44 14 45 4 40 5c-4 0-6 5-8 9ZM30 15l-6 7m10-7 6 7" />
            <g transform="rotate(18 23 32)">
              <path d="M13 37c3-3 3-6 3-10a7 7 0 0 1 14 0c0 4 0 7 3 10ZM13 40h20m-13 3a3 3 0 0 0 6 0M23 20v-3" />
            </g>
            <g transform="rotate(-18 41 32)">
              <path d="M31 37c3-3 3-6 3-10a7 7 0 0 1 14 0c0 4 0 7 3 10ZM31 40h20m-13 3a3 3 0 0 0 6 0M41 20v-3" />
            </g>
          </svg>
        </button>
      </section>
      <WeddingInvitationCollage />
      </main>
    </>
  );
}
